// extracted by mini-css-extract-plugin
var _1 = "EntityArchivedIcon-moduleentityArchivedIconContainer__u1fL2 IconNG-moduleiconContainer__SxWZ0";
export { _1 as "entityArchivedIconContainer" }
